import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useGuest } from "@/context/GuestContext";
import { UpgradeModal } from "@/components/billing/UpgradeModal";
import { api } from "@/lib/api";
import { usePlatform } from "@/lib/platform";

const BillingContext = createContext(null);
const GUEST_ENT = { plan_code: "free", full_catalog: false, guest: true };

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const maintenance = usePlatform().maintenance === true && !["admin", "owner"].includes(user?.role);
  const [billing, setBilling] = useState(null);
  const [upgrade, setUpgrade] = useState(null);
  const { isGuest, openAuth } = useGuest();

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
      return data;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => { if (!user) setBilling(null); else if (!maintenance) refresh(); }, [user, refresh, maintenance]);

  const openUpgrade = useCallback((title = null) => (isGuest ? openAuth({ reason: "premium", title }) : setUpgrade({ title })), [isGuest, openAuth]);

  return (
    <BillingContext.Provider value={{ billing, ent: billing?.entitlements || (isGuest ? GUEST_ENT : undefined), refresh, openUpgrade }}>
      {children}
      <UpgradeModal open={Boolean(upgrade)} title={upgrade?.title} onOpenChange={(o) => !o && setUpgrade(null)} />
    </BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);

export const isCardLocked = (ent, t) => Boolean(ent && !ent.full_catalog && t.access_tier !== "free" && !(t.type === "series" && t.free_episodes > 0));
export const hasFreeEpisode = (ent, t) => Boolean(ent && !ent.full_catalog && t.access_tier !== "free" && t.type === "series" && t.free_episodes > 0);
